"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vuex_1 = require("vuex");
const vue_property_decorator_1 = require("vue-property-decorator");
const modules_1 = require("@/store/modules");
const base_button_vue_1 = tslib_1.__importDefault(require("@/components/base-button/base-button.vue"));
let WLTPModal = class WLTPModal extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.extraContent = false;
    }
    /**
     * Lifecylce methods
     */
    beforeMount() {
        this.emission = this.selectedVehicle.emission;
        this.pertrolType = 'MANUAL' in this.emission.co2EmissionCombinedMax ? 'MANUAL' : 'AUTOMATIC';
    }
    /**
     * Methods
     */
    toggleExtraContentModal() {
        this.extraContent = !this.extraContent;
    }
    /**
     * Computed properties
     */
    get getModalTitle() {
        return !this.extraContent ? 'Verbrauch und Emissionen' : 'Technische Daten';
    }
};
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)()
], WLTPModal.prototype, "message", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)()
], WLTPModal.prototype, "title", void 0);
WLTPModal = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'WLTPModal',
        components: { BaseButton: base_button_vue_1.default },
        computed: Object.assign({}, (0, vuex_1.mapGetters)(modules_1.MODULES.VEHICLE_SELECTOR, ['selectedVehicle'])),
    })
], WLTPModal);
exports.default = WLTPModal;
